<section class="test-header">
  <div class="test-header__row">
    <div class="test-header__title-group">
      <button type="button" class="test-header__back-link" (click)="goBackToOverview()" aria-label="Back to heat trace overview">
        &uarr;
      </button>
      <h2 class="test-header__title">{{ viewModel.tagNumber }}</h2>
    </div>

    <ng-container *ngIf="overview$ | async as overview">

      <div class="test-header__block">
        <div class="test-header__label">Current Step</div>
        <div class="test-header__value">Painting</div>
      </div>


      <div class="test-header__checklist-status" *ngIf="overview.disciplineStatuses?.length">
        <div class="test-header__label">Checklist status</div>
        <div class="test-header__discipline-statuses">
        <app-discipline-status-circle
          *ngFor="let ds of overview.disciplineStatuses"
          class="test-header__discipline-status"
          [status]="ds.status?.name"
          [disciplineNumber]="ds.disciplineNumber"
        ></app-discipline-status-circle></div>
      </div>

      <div class="test-header__block">
        <div class="test-header__label">Piping RFC</div>
        <div class="test-header__value">{{overview?.pipeTest.handoverDate}}</div>
      </div>

    </ng-container>

  </div>



  <p class="test-header__meta" *ngIf="viewModel.elementType && viewModel.elementTagNumber">
    Element: {{ viewModel.elementType }} / {{ viewModel.elementTagNumber }}
  </p>
</section>


